import GET_ARTICLES from '../plugins/getArticles';
import GET_CATEGORIES from '../plugins/getCategories';
import SLIDER from '../class/slider';

const [ w, d, mq ] = [ window, document, window.matchMedia( "(max-width: 900px)" ) ]

const productsSlider = new SLIDER({
  obj:'.block-products__list',
  slickOpt: {
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: true,
    variableWidth: true,
    centerMode: true,
    centerPadding: 0,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 1000,
    speed: 2500,
    easing: 'easeInOutExpo',
    useCSS: true
  }
});

const jqInit = () => {

  w.jQuery = $;

  $.when(
    w.load['mainvisual'],
    $.getScript('/asset/js/vendor/jquery.mb.YTPlayer.min.js')
  ).then( () => {
    const $MV = $('[data-plugin="ytplayer"]');
    const param = id => `{
      videoURL: '${id}',
      containment: '.mainvisual__body',
      mute: true,
      showControls: false,
      autoPlay: true,
      useOnMobile: true,
      showYTLogo: false,
      abundance: '${(mq.matches)? 0.01: 0.07}',
      stopMovieOnBlur: false,
      loop: true,
      startAt: 0,
      anchor: 'center,center',
      quality: 'default'
    }`.replace(/\n|\s/g,'');
    $MV.attr('data-property',param('YQQ5zJV-DYc'));
    $MV.YTPlayer();
    $MV.empty();
    $MV.YTPPlay();
  });

  // ticker
  $.when( w.load['mainvisual'] ).then( () => {
    let makeItem = item => $(`
      <a href="${item.href}" class="link">
        <span class="cat">［${item.category.name}］</span>
        <span class="subject">${item.title}</span>
      </a>
    `)[0];
    GET_ARTICLES( '.block-ticker__article[data-plugin="getArticles"]', { makeItem });
  });

  // products
  $.when( w.load['block-products'] ).then( () => {
    let makeItem = item => $(`
      <li class="block-products-item">
        <a class="block-products-item__link" href="${item.href}">
          <figure class="block-products-item__img">
            <div class="block-products-item__img-cover" style="background-image:url(${item.thumb})"><img src="${item.thumb}" alt="${item.title}" width="220"></div>
            <span class="cate">${item.category.name}</span>
          </figure>
          <div class="block-products-item__body">
            <span class="subject ${item.is_new ? 'is-new': ''}">${item.title.str_truncate(40).replace(/ＤＴｉ|DTi/,'DT<span class="text-secondary">i</span>')}</span>
          </div>
        </a>
      </li>
    `)[0];
    GET_ARTICLES( '.block-products__list[data-plugin="getArticles"]', { makeItem }).then( () => {

      // アイテム数を二倍にする
      if( $('.block-products-item').length <= 5 ){
        $('.block-products-item').each( (i, v) => $(v).clone().appendTo( v.parentNode ) );
      }

      if( !mq.matches ) productsSlider.init();
      else $('.block-products-item').slice(3,-1).remove();

    });
  });

  // news
  $.when(w.load['block-news']).then( () => {
    let makeItem = item => $(`
      <li class="block-news-item">
        <span class="date">${item.date}</span>
        <a href="${item.category.href}" class="cate">${item.category.name}</a>
        <a class="block-news-item__link" href="${item.href}">
          <span class="subject ${item.is_new ? 'is-new': ''}">${item.title}</span>
        </a>
      </li>
    `)[0]
    GET_ARTICLES('.block-news__list[data-plugin="getArticles"]', { makeItem });
    GET_CATEGORIES('.block-news__catlist[data-plugin="getCategories"]');
  });

  // fixed sns
  $.when( w.load['footer'] ).then( () => {
    // ボタンの色をスクロール量で変化させる
    const $fixedBtn = $('.footer__social.is-fixed').addClass('is-dark');
    $.scrollspy({
      trigger: w.innerHeight - 200,
      onBefore() {
        $fixedBtn.addClass('is-dark');
      },
      onAfter() {
        $fixedBtn.removeClass('is-dark');
      }
    })
  });

}

export default function HOME() {

  $( jqInit );

}